// Shared vendor similarity check — Issue #190. Used by both AddVendorSheet
// implementations (VendorCatalogPage.js, PurchasingQueuePage.js) so the
// matching rule can't drift between them, the same lesson #18 already
// taught this app about duplicated formulas living in two places.
// Warns, never blocks — a real distinct vendor can still share a phone
// number (shared office) or a near-identical name (a different branch of
// the same supplier).
import { supabase } from './supabase';

function normalizeName(name) {
  return (name || '')
    .toLowerCase()
    .replace(/[.,]/g, '')
    .replace(/\b(inc|llc|co|corp|company|ltd)\b/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizePhone(phone) {
  return (phone || '').replace(/\D/g, '');
}

// The matching rule itself, over a list already in hand. Split out at Session
// 78n10 for #194's bulk import, which asks the same question of up to a few
// hundred rows at once — calling checkVendorSimilarity per row would have been
// one SELECT per row. The rule lives here so the single-vendor form and the
// importer cannot drift apart, which is the same reason this file exists.
export function findSimilarVendor(name, phone, email, vendors) {
  const normName = normalizeName(name);
  const normPhone = normalizePhone(phone);
  const normEmail = (email || '').trim().toLowerCase();

  for (const v of vendors || []) {
    const vNormName = normalizeName(v.name);
    const nameMatch = normName && vNormName && (
      vNormName === normName ||
      vNormName.includes(normName) ||
      normName.includes(vNormName)
    );
    const phoneMatch = normPhone && normalizePhone(v.phone) === normPhone;
    const emailMatch = normEmail && (v.email || '').trim().toLowerCase() === normEmail;

    if (nameMatch || phoneMatch || emailMatch) {
      return { matched: true, matchedVendor: v };
    }
  }
  return { matched: false, matchedVendor: null };
}

export async function checkVendorSimilarity(name, phone, email) {
  const { data } = await supabase
    .from('inventory_vendors')
    .select('id, name, phone, email')
    .eq('is_active', true);

  if (!data) return { matched: false, matchedVendor: null };
  return findSimilarVendor(name, phone, email, data);
}